<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p class="paragraph text-text-neutral-primary" v-html="text"></p>
</template>

<script setup lang="ts">
  defineProps<{
    text: string;
  }>();
</script>

<style scoped>
  .paragraph:deep(a) {
    display: inline-block;
  }
</style>
